// Haelt den angemeldeten Benutzer fuer die gesamte Oberflaeche vor.
// Beim Start wird einmal /api/me gefragt: das Session-Cookie ist httpOnly,
// JavaScript kann also nicht selbst nachsehen, ob noch jemand angemeldet ist.

import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { api } from './api.js'

const SitzungKontext = createContext(null)

export function SitzungProvider({ children }) {
  const [benutzer, setBenutzer] = useState(null)
  const [laedt, setLaedt] = useState(true)

  useEffect(() => {
    let abgebrochen = false
    api('/me')
      .then((daten) => {
        if (!abgebrochen) setBenutzer(daten.benutzer)
      })
      .catch(() => {
        // 401 ist der Normalfall, wenn niemand angemeldet ist.
        if (!abgebrochen) setBenutzer(null)
      })
      .finally(() => {
        if (!abgebrochen) setLaedt(false)
      })
    return () => {
      abgebrochen = true
    }
  }, [])

  const anmelden = useCallback(async (email, passwort) => {
    const daten = await api('/login', { methode: 'POST', koerper: { email, passwort } })
    setBenutzer(daten.benutzer)
    return daten.benutzer
  }, [])

  // Fuer Wege, bei denen der Server die Sitzung schon gesetzt hat — etwa nach
  // dem Vergeben des ersten Passworts.
  const neuAnmelden = useCallback((neuerBenutzer) => {
    setBenutzer(neuerBenutzer)
  }, [])

  const abmelden = useCallback(async () => {
    try {
      await api('/logout', { methode: 'POST' })
    } finally {
      // Auch wenn der Server nicht erreichbar war: lokal abmelden.
      setBenutzer(null)
    }
  }, [])

  return (
    <SitzungKontext.Provider value={{ benutzer, laedt, anmelden, neuAnmelden, abmelden }}>
      {children}
    </SitzungKontext.Provider>
  )
}

export function useSitzung() {
  const wert = useContext(SitzungKontext)
  if (!wert) throw new Error('useSitzung darf nur innerhalb von <SitzungProvider> stehen')
  return wert
}
